function Bold({ children }) {
    return (
        <span className='font-bold'>
            {children}
        </span>
    );
}

export default Bold;
